<span class="badge pillbadge-status rounded-pill {{badgeStatusStyleClass}}" [ngClass]="{ 'cursor-pointer': clickable, 'disabled': disable }" [attr.data-testid]="'request-status'">
  <!-- Generic icon, based on Bootstrap Icons -->
  @if (iconTag) {
    <icon [icon]="iconTag"></icon>
  }

  <!-- Pill badge data -->
  {{ data }}
</span>
